export enum AppRoutes {
  Folders = 'folders',
  Files = 'files',
  Users = 'users',
  Downloads = 'downloads',
  Dashboard = 'dashboard',
  Shared = 'shared',
  Videos = 'videos',
  Customers = 'customers',
  Live = 'live',
  Events = 'events',
}
